"use strict";

import Common from "../Common";
import CommonGame from "../CommonGame";
import MyGame from  "./MyGame";
import FillLayer from  "./FillLayer";
import DrawLayer from  "./DrawLayer";

//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
function Canvas() {
    PIXI.Container.call(this);


    // Attributes.
    this._fillLayer = null;
    this._drawLayer = null;

    // Sprites.
    this._bgSprite = null;
    this._borderSprite = null;


    // Constants.
    this.WIDTH = CommonGame.CANVAS_WIDTH;//Common.STAGE_WIDTH
    this.HEIGHT = CommonGame.CANVAS_HEIGHT;//Common.STAGE_HEIGHT
}
export default Canvas;
//module.exports = Canvas;
Canvas.prototype = Object.create(PIXI.Container.prototype);
Canvas.prototype.constructor = Canvas;


//===================================================
//
// Public
//
//===================================================

Canvas.prototype.init = function () {
    // Bg.
    this.addChild(CommonGame.createCanvasBg());

    this._bgSprite = new PIXI.Sprite(Common.blankTexture);
    this._bgSprite.anchor = new PIXI.Point(0.5, 0.5);
    this._bgSprite.width = this.WIDTH;
    this._bgSprite.height = this.HEIGHT;
    this._bgSprite.tint = 0xffffff;

    this.addChild(this._bgSprite);

    // Layers.
    // Fill.
    this._fillLayer = new FillLayer();
    this._fillLayer.init();
    this.addChild(this._fillLayer);
    // Draw.
    this._drawLayer = new DrawLayer();
    this._drawLayer.init();
    this.addChild(this._drawLayer);

    let galleryKey = "drawing";
    if (CommonGame.selectedGallery === 1) galleryKey = "colouring";

    // Border.
    this._borderSprite = new PIXI.Sprite(Common.assets.getTexture("canvas_" + galleryKey));
    this._borderSprite.anchor = new PIXI.Point(0.5, 0.5);
    this.addChild(this._borderSprite);

    // Listen to HUD controls.
    Common.game.hud.signals.onDrawModeChanged.add(this._onDrawMode_Changed, this);

    // Start with the pencil
    this._onDrawMode_Changed(CommonGame.TOOL.PENCIL);
};

Canvas.prototype.update = function () {
    this._fillLayer.update();
    this._drawLayer.update();
};

Canvas.prototype.animateIn = function () {
    this.y -= 100;
    this.alpha = 0;
    TweenMax.to(this, 0.25, {
        alpha: 1,
        y: this.y + 100,
        ease: Sine.easeOut,
        onComplete: function () {
            Common.game.scene.addTutorialEvent(CommonGame.TUT_EVENT.CANVAS_VISIBLE);
        },
        onCompleteScope: this
    });
};

Canvas.prototype.clear = function () {
    this._fillLayer.clear();
    this._drawLayer.clear();
};


//===================================================
//
// Private
//
//===================================================

// TODO:


//===================================================
//
// Events
//
//===================================================

Canvas.prototype._onDrawMode_Changed = function (selection) {
    if (selection == CommonGame.TOOL.PENCIL
        || selection == CommonGame.TOOL.BRUSH
        || selection == CommonGame.TOOL.SPRAY
        || selection == CommonGame.TOOL.STAMP
        || selection == CommonGame.TOOL.INK_POT
        || selection == CommonGame.TOOL.ERASER) {
        this._drawLayer.setEnabled(true);
        this._fillLayer.setEnabled(false);
    }
    else if (selection == CommonGame.TOOL.BUCKET) {
        this._drawLayer.setEnabled(false);
        this._fillLayer.setEnabled(true);
    }

    // Sfx.
    Common.audio.playSound("sfx_tool_paintbrush_select_00");
};


//===================================================
//
// Getters / Setters
//
//===================================================

Object.defineProperty(
    Canvas.prototype,
    "fillLayer",
    {
        get: function () {
            return this._fillLayer;
        }
    });

Object.defineProperty(
    Canvas.prototype,
    "drawLayer",
    {
        get: function () {
            return this._drawLayer;
        }
    });